// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"637":"c88f9743","681":"cb85e932"}[chunkId] + ".chunk.js";
};